import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Button, Box } from "@mui/material";
import { styled } from "@mui/material/styles";

const Track = styled(Box)(({ theme, ownerState }) => ({
  width: 44,
  height: 22,
  borderRadius: 999,
  display: "flex",
  alignItems: "center",
  padding: 2,
  transition: "background-color 200ms",
  backgroundColor: theme.palette.primary.main,
}));

const Thumb = styled(Box)(({ ownerState }) => ({
  width: 18,
  height: 18,
  borderRadius: "50%",
  backgroundColor: "#fff",
  boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
  transform: ownerState.isOn ? "translateX(20px)" : "translateX(0)",
  transition: "transform 200ms",
}));

const ToggleButton = ({
  label = "PHI",
  isOn: controlledIsOn,
  onChange,
  onLabel = "Hidden",
  offLabel = "Visible",
  className = "",
  ...rest
}) => {
  const [isOn, setIsOn] = useState(!!controlledIsOn);

  useEffect(() => {
    if (typeof controlledIsOn === "boolean") setIsOn(controlledIsOn);
  }, [controlledIsOn]);

  const handleToggle = () => {
    const next = !isOn;
    if (typeof onChange === "function") onChange(next);
    if (typeof controlledIsOn !== "boolean") setIsOn(next);
  };

  return (
    <Button
      variant="contained"
      onClick={handleToggle}
      disableElevation
      sx={{
        bgcolor: "#fff",
        color: "text.primary",
        textTransform: "none",
        padding: 0,
        minWidth: 0,
        "&:hover": { bgcolor: "#fff" },
        display: "flex",
        alignItems: "center",
        height: 32,
        borderRadius: 20,
        gap: 1,
        px: 1,
      }}
      className={className}
      {...rest}
    >
      <Box component="span" sx={{ fontWeight: 600 }}>
        {label} {isOn ? onLabel : offLabel}
      </Box>

      <Track ownerState={{ isOn }}>
        <Thumb ownerState={{ isOn }} />
      </Track>
    </Button>
  );
};

ToggleButton.propTypes = {
  label: PropTypes.node,
  isOn: PropTypes.bool,
  onChange: PropTypes.func,
  onLabel: PropTypes.node,
  offLabel: PropTypes.node,
  className: PropTypes.string,
};

export default ToggleButton;
